import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCustomer } from "./customerAPI";

const initialState = {
  value: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
};

export const fetchCustomer = createAsyncThunk(
  "customer/fetchCustomer",
  async (payload) => {
    const response = await getCustomer(payload);
    return response.data;
  }
);

export const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {resetData: (state) => initialState,},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomer.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      });
  },
});

export const {resetData} = customerSlice.actions;

export const selectCustomer = (state) => state.customer.value;
export const selectLoading = (state) => state.customer.loading;
export const selectError = (state) => state.customer.error;
export const selectPageNo = (state) => state.customer.pageNo;
export const selectPageSize = (state) => state.customer.pageSize;
export const selectTotalRecord = (state) => state.customer.totalRecord;

export default customerSlice.reducer;
